import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { ServicesTwoComponent } from './components/pages/services-two/services-two.component';
import { WebsiteDevelopment } from './components/pages/website-development/website-development.component';
import { PortfolioComponent } from './components/pages/portfolio-list/portfolio-list.component';
import { MobileDevelopment } from './components/pages/mobile-development/mobile-development.component';
import { ErpCmsDevelopment } from './components/pages/erp-cms/erp-cms.component';
import { CustomSoftwareDevelopment } from './components/pages/custom-software-development/custom-software-development.component';
import { DigitalMarketing } from './components/pages/digital-marketing/digital-marketing.component';
import { HostingRegistration } from './components/pages/hosting-registration/hosting-registration.component';

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'about', component: AboutComponent},
    {path: 'services', component: ServicesTwoComponent},
    {path: 'website-development', component: WebsiteDevelopment},
    {path: 'mobile-development', component: MobileDevelopment},
    {path: 'erp-cms', component: ErpCmsDevelopment},
    {path: 'custom-software-development', component: CustomSoftwareDevelopment},
    {path: 'digital-marketing', component: DigitalMarketing},
    {path: 'hosting-registration', component: HostingRegistration},
    {path: 'portfolio', component: PortfolioComponent},
    {path: 'contact', component: ContactComponent},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
